import React from 'react';
import { useTranslation } from '@common/hooks/useTranslation';
import { Heading } from '@components/Heading';
import { BellIcon, CommentIcon, MaxAdIcon } from '@components/Icon';
import { Text } from '@components/Text';

type Props = {
  emailAddress: string;
};

export const WhatHappensNextInfo = ({ emailAddress }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col pt-[24px] p-lg bg-background-neutral">
      <div className="flex flex-col gap-md">
        <Heading level="h2">
          {t('postJobSuccessPage.description.whatHappensNext')}
        </Heading>

        <div className="flex flex-row gap-md items-start">
          <div className="px-[6px] pt-[4px]">
            <BellIcon variant="outline" tone="brand" height="medium" />
          </div>
          <Text>
            {t('postJobSuccessPage.description.applicantAlerts', {
              emailAddress
            })}
          </Text>
        </div>

        <div className="flex flex-row gap-md items-start">
          <div className="pt-[4px]">
            <MaxAdIcon variant="outline" tone="brand" height="medium" />
          </div>
          <Text>
            {t('postJobSuccessPage.description.reviewApplicantsInDashboard')}
          </Text>
        </div>

        <div className="flex flex-row gap-md items-start">
          <div className="px-[4px] pt-[4px]">
            <CommentIcon variant="outline" tone="brand" height="medium" />
          </div>
          <Text>
            {t('postJobSuccessPage.description.connectWithApplicants')}
          </Text>
        </div>
      </div>
    </div>
  );
};
